import { path } from "../utils";
import { VolumeRateOfChange as defaultOptions } from "./defaultOptionsForComputation";

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    if (!Array.isArray(data) || data.length === 0) {
      return [];
    }

    const { period, volumePath } = options;

    if (!period || period < 1) {
      throw new Error("Vol ROC period must be at least 1");
    }

    if (data.length <= period) {
      return new Array(data.length).fill(undefined);
    }

    // Accessor for volume field
    const getVolume = path(volumePath);
    const results = new Array(data.length).fill(undefined);

    for (let i = period; i < data.length; i++) {
      const current = data[i];
      const past = data[i - period];

      if (!current || !past) {
        continue;
      }

      // Extract and convert volume values to numbers
      const currentVolume = Number(getVolume(current));
      const pastVolume = Number(getVolume(past));

      // Validate values and calculate ROC
      if (
        Number.isFinite(currentVolume) &&
        Number.isFinite(pastVolume) &&
        pastVolume !== 0
      ) {
        // Calculate Rate of Change: 100 * ((current / past) - 1)
        results[i] = 100 * (currentVolume / pastVolume - 1);
      }
    }

    return results;
  }

  calculator.undefinedLength = function () {
    return options.period;
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...options, ...x };
    return calculator;
  };

  return calculator;
}
